import { useState, useEffect } from 'react';
import Navigation from '../../components/feature/Navigation';
import Footer from '../home/components/Footer';

export default function TermsPage() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navigation isScrolled={isScrolled} />

      <section className="pt-32 pb-20 bg-slate-50">
        <div className="max-w-4xl mx-auto px-6">
          <h1 className="text-5xl font-bold text-slate-900 mb-6">Algemene Voorwaarden</h1>
          <p className="text-lg text-slate-600 mb-8">Laatst bijgewerkt: januari 2024</p>

          <div className="prose prose-lg max-w-none">
            <section className="mb-12">
              <h2 className="text-3xl font-bold text-slate-900 mb-4">1. Algemeen</h2>
              <p className="text-slate-700 leading-relaxed mb-4">
                Deze algemene voorwaarden zijn van toepassing op alle overeenkomsten tussen Utrecht Airport 
                Taxi en de opdrachtgever. Door het boeken van een rit gaat u akkoord met deze voorwaarden.
              </p>
              <p className="text-slate-700 leading-relaxed">
                Utrecht Airport Taxi is gevestigd in Utrecht en geregistreerd bij de Kamer van Koophandel 
                onder nummer [KVK NUMMER].
              </p>
            </section>

            <section className="mb-12">
              <h2 className="text-3xl font-bold text-slate-900 mb-4">2. Boekingen</h2>
              <p className="text-slate-700 leading-relaxed mb-4">
                Boekingen kunnen worden gemaakt via:
              </p>
              <ul className="list-disc pl-6 mb-4 text-slate-700 space-y-2">
                <li>Onze website</li>
                <li>Telefonisch</li>
                <li>WhatsApp</li>
                <li>E-mail</li>
              </ul>
              <p className="text-slate-700 leading-relaxed mb-4">
                Een boeking is definitief wanneer u een bevestiging heeft ontvangen van Utrecht Airport Taxi. 
                Wij adviseren om minimaal 24 uur van tevoren te reserveren voor gegarandeerde beschikbaarheid.
              </p>
              <p className="text-slate-700 leading-relaxed">
                Bij het boeken dient u correcte gegevens te verstrekken, waaronder ophaaladres, 
                bestemmingsadres, datum, tijd en aantal passagiers. Bij luchthaventritten is het vluchtnummer 
                verplicht.
              </p>
            </section>

            <section className="mb-12">
              <h2 className="text-3xl font-bold text-slate-900 mb-4">3. Prijzen en Betaling</h2>
              <p className="text-slate-700 leading-relaxed mb-4">
                Alle prijzen zijn vaste all-in prijzen en zijn inclusief:
              </p>
              <ul className="list-disc pl-6 mb-4 text-slate-700 space-y-2">
                <li>BTW</li>
                <li>Alle kilometers</li>
                <li>Wachttijd bij ophalen vanaf luchthaven</li>
                <li>Vluchttracking</li>
              </ul>
              <p className="text-slate-700 leading-relaxed mb-4">
                Er worden geen nachttoeslagen, weekendtoeslagen of andere verborgen kosten gerekend. 
                De prijs die u bij het boeken ziet, is de prijs die u betaalt.
              </p>
              <p className="text-slate-700 leading-relaxed mb-4">
                Betaling kan plaatsvinden via:
              </p>
              <ul className="list-disc pl-6 mb-4 text-slate-700 space-y-2">
                <li>iDEAL (vooraf online)</li>
                <li>Creditcard</li>
                <li>Pin (in de taxi)</li>
                <li>Contant (in de taxi)</li>
              </ul>
            </section>

            <section className="mb-12">
              <h2 className="text-3xl font-bold text-slate-900 mb-4">4. Annulering en Wijziging</h2>
              <p className="text-slate-700 leading-relaxed mb-4">
                U kunt uw boeking kosteloos annuleren of wijzigen tot 24 uur voor de geplande ophaaltijd. 
                Annuleringen binnen 24 uur voor vertrek kunnen leiden tot annuleringskosten van 50% van 
                het totaalbedrag.
              </p>
              <p className="text-slate-700 leading-relaxed">
                Bij no-show (niet verschijnen zonder annulering) wordt 100% van het totaalbedrag in rekening 
                gebracht.
              </p>
            </section>

            <section className="mb-12">
              <h2 className="text-3xl font-bold text-slate-900 mb-4">5. Ophalen en Wachttijd</h2>
              <p className="text-slate-700 leading-relaxed mb-4">
                Onze chauffeur is op de afgesproken tijd aanwezig op het ophaaladres. Bij ophalen vanaf 
                een luchthaven volgen wij uw vlucht automatisch en passen de ophaaltijd aan bij vertraging.
              </p>
              <p className="text-slate-700 leading-relaxed mb-4">
                Standaard wachttijd:
              </p>
              <ul className="list-disc pl-6 mb-4 text-slate-700 space-y-2">
                <li>Bij ophalen vanaf woonadres: 5 minuten gratis wachttijd</li>
                <li>Bij ophalen vanaf luchthaven: 60 minuten gratis wachttijd na landing</li>
              </ul>
              <p className="text-slate-700 leading-relaxed">
                Extra wachttijd wordt berekend tegen €0,50 per minuut.
              </p>
            </section>

            <section className="mb-12">
              <h2 className="text-3xl font-bold text-slate-900 mb-4">6. Bagage</h2>
              <p className="text-slate-700 leading-relaxed mb-4">
                Standaard is er ruimte voor normale handbagage en koffers. Bij het boeken kunt u aangeven 
                of u extra bagage heeft. Voor extra bagage adviseren wij een stationwagon te boeken.
              </p>
              <p className="text-slate-700 leading-relaxed">
                Wij zijn niet aansprakelijk voor schade aan bagage, tenzij deze is veroorzaakt door grove 
                nalatigheid van onze chauffeur.
              </p>
            </section>

            <section className="mb-12">
              <h2 className="text-3xl font-bold text-slate-900 mb-4">7. Passagiers</h2>
              <p className="text-slate-700 leading-relaxed mb-4">
                Het aantal passagiers mag niet meer zijn dan bij de boeking is opgegeven en niet meer dan 
                de toegestane capaciteit van het voertuig:
              </p>
              <ul className="list-disc pl-6 mb-4 text-slate-700 space-y-2">
                <li>Sedan: maximaal 4 personen</li>
                <li>Stationwagon: maximaal 4 personen</li>
                <li>Taxibus: maximaal 8 personen</li>
              </ul>
              <p className="text-slate-700 leading-relaxed">
                Kinderen jonger dan 3 jaar moeten in een kinderzitje worden vervoerd. U kunt bij het boeken 
                aangeven of u een kinderzitje nodig heeft.
              </p>
            </section>

            <section className="mb-12">
              <h2 className="text-3xl font-bold text-slate-900 mb-4">8. Gedrag</h2>
              <p className="text-slate-700 leading-relaxed mb-4">
                Passagiers dienen zich respectvol te gedragen tegenover de chauffeur en andere passagiers. 
                De chauffeur heeft het recht om passagiers te weigeren of de rit te beëindigen bij:
              </p>
              <ul className="list-disc pl-6 mb-4 text-slate-700 space-y-2">
                <li>Agressief of bedreigend gedrag</li>
                <li>Beschadiging van het voertuig</li>
                <li>Overmatig alcoholgebruik of drugsgebruik</li>
                <li>Roken in het voertuig</li>
              </ul>
              <p className="text-slate-700 leading-relaxed">
                In deze gevallen wordt het volledige ritbedrag in rekening gebracht zonder restitutie.
              </p>
            </section>

            <section className="mb-12">
              <h2 className="text-3xl font-bold text-slate-900 mb-4">9. Aansprakelijkheid</h2>
              <p className="text-slate-700 leading-relaxed mb-4">
                Utrecht Airport Taxi is niet aansprakelijk voor:
              </p>
              <ul className="list-disc pl-6 mb-4 text-slate-700 space-y-2">
                <li>Gemiste vluchten door verkeersomstandigheden of andere overmacht</li>
                <li>Verlies of diefstal van persoonlijke eigendommen</li>
                <li>Indirecte schade</li>
              </ul>
              <p className="text-slate-700 leading-relaxed">
                Onze aansprakelijkheid is in alle gevallen beperkt tot het bedrag van de geboekte rit.
              </p>
            </section>

            <section className="mb-12">
              <h2 className="text-3xl font-bold text-slate-900 mb-4">10. Klachten</h2>
              <p className="text-slate-700 leading-relaxed mb-4">
                Klachten over onze dienstverlening kunnen worden ingediend via:
              </p>
              <ul className="list-disc pl-6 mb-4 text-slate-700 space-y-2">
                <li>E-mail: info@utrechtairporttaxi.nl</li>
                <li>Telefoon: 06 1234 5678</li>
              </ul>
              <p className="text-slate-700 leading-relaxed">
                Wij streven ernaar klachten binnen 7 werkdagen af te handelen. Zie ons klachtenbeleid voor 
                meer informatie.
              </p>
            </section>

            <section className="mb-12">
              <h2 className="text-3xl font-bold text-slate-900 mb-4">11. Toepasselijk Recht</h2>
              <p className="text-slate-700 leading-relaxed">
                Op deze algemene voorwaarden is Nederlands recht van toepassing. Geschillen worden voorgelegd 
                aan de bevoegde rechter in het arrondissement Utrecht.
              </p>
            </section>

            <section className="mb-12">
              <h2 className="text-3xl font-bold text-slate-900 mb-4">12. Contact</h2>
              <div className="bg-slate-50 rounded-xl p-6">
                <p className="text-slate-900 font-semibold mb-2">Utrecht Airport Taxi</p>
                <p className="text-slate-700">KvK: [KVK NUMMER]</p>
                <p className="text-slate-700">E-mail: info@utrechtairporttaxi.nl</p>
                <p className="text-slate-700">Telefoon: 06 1234 5678</p>
                <p className="text-slate-700">Adres: Utrecht, Nederland</p>
              </div>
            </section>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
